export const RAD = Math.PI / 180

// Natural Earth I projection, as in d3-geo's geoNaturalEarth1Raw. Takes and returns radians.
export function naturalEarth(lambda, phi) {
  const phi2 = phi * phi
  const phi4 = phi2 * phi2
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ]
}

// The shortest path over the globe between two [lng, lat] points, as a function from 0..1
// to [lng, lat]. Flights between continents curve the way they do on airline maps.
export function greatCircle(from, to) {
  const a = toVector(from)
  const b = toVector(to)
  const angle = Math.acos(Math.min(1, Math.max(-1, a[0] * b[0] + a[1] * b[1] + a[2] * b[2])))
  if (angle < 1e-9) return () => from

  const sin = Math.sin(angle)
  return (u) => {
    const s0 = Math.sin((1 - u) * angle) / sin
    const s1 = Math.sin(u * angle) / sin
    const x = s0 * a[0] + s1 * b[0]
    const y = s0 * a[1] + s1 * b[1]
    const z = s0 * a[2] + s1 * b[2]
    return [Math.atan2(y, x) / RAD, Math.atan2(z, Math.hypot(x, y)) / RAD]
  }
}

function toVector([lng, lat]) {
  const cosLat = Math.cos(lat * RAD)
  return [cosLat * Math.cos(lng * RAD), cosLat * Math.sin(lng * RAD), Math.sin(lat * RAD)]
}
